import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { AUTOMATIC_COUPON_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateAutomaticCouponSettingTranslationAction = createAsyncThunk(
    'coupon/updateAutomaticCouponSettingTranslationAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(`${ AUTOMATIC_COUPON_SETTINGS_PATH }/${ data.automaticCouponType }/translation`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateAutomaticCouponSettingTranslationSlice = createSlice({
    name: 'updateAutomaticCouponSettingTranslationSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateAutomaticCouponSettingTranslationAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateAutomaticCouponSettingTranslationAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateAutomaticCouponSettingTranslationAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateAutomaticCouponSettingTranslationState = (state) => state.coupon.updateAutomaticCouponSettingTranslation;
export default updateAutomaticCouponSettingTranslationSlice.reducer;
